import {
  GET_JOB_LIST_LOADING, GET_JOB_LIST, SUBMIT_JOB_SUCCESS, GENERATE_JOB_FROM_PROMPT_SUCCESS, GENERATE_JOB_DESCRIPTION_SUCCESS, ENHANCE_JOB_DESCRIPTION_SUCCESS, DELETE_JOB_SUCCESS, GET_JOB_BY_ID_SUCCESS, CLEAR_LATEST_JOB, CLEAR_LATEST_JOB_DONE, GET_SKILLS_LIST, ADD_NEW_SKILL, CREATE_JOB_ASSESSMENT_SUCCESS,
  GET_HIRING_STAGES, GET_CANDIDATE_HIRING_STAGE, FETCH_AVAILABLE_SLOTS, GET_QUALIFY_QUESTIONS, CLEAR_QUALIFYING_QUESTIONS, SET_SELECTED_QUESTION,
  CLEAR_INITIATE_WEB_CALL,
  INITIATE_WEB_CALL_REQUEST,
  INITIATE_WEB_CALL_SUCCESS,
  INITIATE_WEB_CALL_FAILURE
} from '../Types/types';

const initialState = {
  jobList: [],
  pagination: { total: 0, skip: 0, limit: 10 },
  error: null,
  loading: false,
  latestJob: null,
  hasAnyJobs: null,
  skills: [],
  availableSlots: [],
  qualifyingQuestions: [],
  selectedQuestion: [],
  initialWebCallState: [],
  stagesMap: [{
    name: "Voice Call",
    url: "/images/circle-phone-black.svg",
  },
  {
    name: "Resume Uploaded",
    url: "/images/clock-green.svg",
  },
  {
    name: "Resume Pending",
    url: "/images/clock-green.svg",
  },
  {
    name: "Assessment",
    url: "/images/person-check-black.svg",
  },
  {
    name: "Video Call",
    url: "/images/play-video-black.svg",
  },
  ]
};

export default function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_LATEST_JOB:
      return { ...state, latestJob: null, loading: true };
    case CLEAR_LATEST_JOB_DONE:
      return { ...state, loading: false };
    case GET_JOB_LIST_LOADING:
      return { ...state, loading: true };
    case GET_JOB_LIST:
      return { ...state, loading: false, jobList: action.payload.jobs, pagination: action.payload.pagination, error: null };
    case "SET_HAS_ANY_JOBS":
      return { ...state, hasAnyJobs: action.payload };
    case SUBMIT_JOB_SUCCESS:
      return { ...state, loading: false, jobList: [action.payload, ...state.jobList], latestJob: { id: action.payload, generate_description_quota_left: 3 }, error: null, hasAnyJobs: true };
    case GENERATE_JOB_FROM_PROMPT_SUCCESS:
      return { ...state, error: null };
    case GENERATE_JOB_DESCRIPTION_SUCCESS:
      return { ...state, latestJob: { ...state.latestJob, ...action.payload.data }, error: null };
    case ENHANCE_JOB_DESCRIPTION_SUCCESS:
      return { ...state, latestJob: { ...state.latestJob, ...action.payload.data }, error: null };
    case DELETE_JOB_SUCCESS:
      return { ...state, error: null }
    case GET_JOB_BY_ID_SUCCESS:
      return { ...state, latestJob: { ...action.payload, id: action.payload.id, generate_description_quota_left: action.payload.generate_description_quota_left ?? 3, }, error: null, };
    case GET_SKILLS_LIST:
      return { ...state, skills: action.payload };
    case ADD_NEW_SKILL:
      return { ...state, skills: [...state.skills, action.payload] };
    case CREATE_JOB_ASSESSMENT_SUCCESS:
      return { ...state, latestJob: { ...state.latestJob, assessment_id: action.payload?.assessment_id || null, }, };
    case GET_HIRING_STAGES:
      return { ...state, hiringStages: action.payload };
    case GET_CANDIDATE_HIRING_STAGE:
      return { ...state, candidateHiringStage: action.payload };
    case FETCH_AVAILABLE_SLOTS:
      return { ...state, availableSlots: action.payload };
    case GET_QUALIFY_QUESTIONS:
      return { ...state, qualifyingQuestions: action.payload };
    case CLEAR_QUALIFYING_QUESTIONS:
      return { ...state, qualifyingQuestions: [] };
    case SET_SELECTED_QUESTION:
      return { ...state, selectedQuestion: action.payload };
    case CLEAR_INITIATE_WEB_CALL:
      return { ...state, initialWebCallState: [] };
    case INITIATE_WEB_CALL_SUCCESS:
      return { ...state, initialWebCallState: action.payload }
    default:
      return state;
  }
}
